import { CommonModule } from "@angular/common";
import { Component, DestroyRef, OnDestroy, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { TableModule } from "primeng/table";

import { BooksReviewService } from "../books-review.service";
import { WorkspacesService } from "../../workspaces.service";
import { DatePickerModule } from "primeng/datepicker";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import {
  TimeFrameFilter,
  ToolData,
  Transaction,
} from "../books-review.component";
import { HotToastService } from "@ngneat/hot-toast";
import { QuickbooksIntegrationService } from "src/app/dashboard/quickbooks-integration.service";
import { MomentModule } from "ngx-moment";
import { EmptyStateComponent } from "src/app/design-system/components/empty-state/empty-state.component";

@Component({
  selector: "transactions-without-payee",
  imports: [
    RouterModule,
    TableModule,
    CommonModule,
    FormsModule,
    BsDropdownModule,
    TooltipModule,
    TypeaheadModule,
    DatePickerModule,
    MomentModule,
    EmptyStateComponent,
  ],
  templateUrl: "./transactions-without-payee.component.html",
  styleUrl: "../books-review.component.scss",
})
export class TransactionsWithoutPayeeComponent {
  booksReviewService = inject(BooksReviewService);
  workspacesService = inject(WorkspacesService);
  localStorage = inject(LocalStorageService);
  quickbooksIntegrationService = inject(QuickbooksIntegrationService);
  toastr = inject(HotToastService);

  date;
  company: any;
  vendors = [];
  loading = true;

  data = [];

  readonly destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.localStorage.set(
      "last_tab",
      "books-review/transactions-without-payee",
    );
    this.localStorage.set("last_tool", "transactions-without-payee");
    this.booksReviewService.onToolChange$.next(null);

    this.workspacesService.$company
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((company) => {
        if (company == null) return;

        this.company = company;

        this.loadData();

        this.quickbooksIntegrationService
          .getVendorsByCompanyId(this.company.id)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(
            (res) => {
              console.log("vendors", res);
              this.vendors = res;
            },
            (err) => {
              console.log(err);
            },
          );
      });

    this.booksReviewService.dateSelected$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((timeFrameFilter: TimeFrameFilter) => {
        this.loadData();
      });
  }

  async markTransactionAsReviewed(transaction, key) {
    let res = await this.booksReviewService.markTransactionAsReviewed(
      this.company.uuid,
      transaction,
      key,
      "transactions-without-payee",
    );

    if (res.reviewed) {
      this.toastr.success(res.message);
      this.data = this.data.filter((t) => t[key] != transaction[key]);
    }
  }

  loadData() {
    this.data = [];
    this.loading = true;
    this.booksReviewService
      .getToolData(this.company.uuid, "transactions-without-payee")
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: ToolData) => {
        console.log("transactions-without-payee", res);
        this.data = res.transactions;
        this.loading = false;
      });
  }

  typeaheadOnSelect(event, item) {
    console.log(event, item);
    item.payee_id = event.item.id;
    item.payee = event.item.name;
  }

  updateTransaction(item) {
    this.loading = true;
    this.booksReviewService.updateTransaction(this.company.uuid, item).then(
      (res) => {
        this.data = this.data.filter((t) => t.purchase_id != res.purchase_id);
        this.loading = false;
        this.toastr.success("Transaction updated successfully!");
      },
      (err) => {
        console.log(err);
        this.loading = false;
        this.toastr.error("Error updating transaction");
      },
    );
  }
}
